import { backendGetOpenAiEmbedding } from "./FirebaseFunctionPointers"

export const getOpenAiTextEmbedding = async (text: string): Promise<any> => {
  return backendGetOpenAiEmbedding(text)
}
